"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("./routes");
var user_hook_1 = require("../context/UserContext/user.hook");
var AuthRoute_1 = __importDefault(require("./AuthRoute"));
var Landing_1 = __importDefault(require("../components/Client/Landing/View/Landing"));
var isEmpty_1 = __importDefault(require("../lib/isEmpty"));
var UnderConstruction_1 = __importDefault(require("../theme/underConstruction/UnderConstruction"));
function ClientRoute(props) {
    var userCntx = (0, user_hook_1.useUser)(), user = props.user;
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_router_dom_1.Switch, null, !(0, isEmpty_1.default)(userCntx.user) && userCntx.user.roles && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AuthRoute_1.default, { Component: Landing_1.default, path: routes_1.ClientRoutes.dashboard, requiredRoles: ["Agent"], user: user }),
            react_1.default.createElement(AuthRoute_1.default, { Component: UnderConstruction_1.default, path: routes_1.ClientRoutes.underConstruction, requiredRoles: ["Agent"], user: user }))))));
}
exports.default = ClientRoute;
